var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.524.464a.5.5 0 0 1 .952 0l1.176 3.622h3.81a.5.5 0 0 1 .293.904L8.674 7.23l1.177 3.622a.5.5 0 0 1-.77.56L6 9.17l-3.081 2.24a.5.5 0 0 1-.77-.56L3.326 7.23.245 4.99a.5.5 0 0 1 .294-.904h3.809L5.524.464Z",
    fill: "#003B58"
  })));
};
export default SvgStar;